export default "__VITE_ASSET__Ow8iDdnr__"